import { cn } from "@/lib/utils";
import Image from "next/image";
import { Button } from "../../button";
import { useHeroCarousel } from "./useHeroCarousel";

export const CarouselThumbnails = () => {
  const { currentIndex, slides, handleSlideChange, handleTimerReset } =
    useHeroCarousel();

  return (
    <div className="flex gap-2 items-center">
      {slides.map((slide, index) => (
        <Button
          key={slide.route}
          variant="ghost"
          size="icon"
          onClick={() => {
            handleSlideChange(index);
            handleTimerReset();
          }}
          className={cn(
            "relative overflow-hidden border-2 transition-all duration-300 rounded",
            "h-12 w-16 sm:h-12 sm:w-20 lg:h-16 lg:w-28",
            index === currentIndex
              ? "border-white scale-105 shadow-lg"
              : "border-white/30 hover:border-white/60 hover:scale-102",
          )}
        >
          <Image
            src={slide.thumbnailUrl}
            alt={`${slide.route} thumbnail`}
            fill
            sizes="(max-width: 640px) 56px, (max-width: 1024px) 80px, 112px"
            className="object-contain w-full h-full p-1"
          />
          {index === currentIndex && (
            <div className="absolute inset-0 bg-white/20 backdrop-blur-[1px]" />
          )}
        </Button>
      ))}
    </div>
  );
};
